import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateGridSmartViews = document.createElement('template');

templateGridSmartViews.innerHTML = `
    <style>${colorHelpersStyles}</style>
    <style>${commonStyles}</style>
    <style>${styles}</style>
    <div class="wrapper">
        <div id="sections" class="panel-content"></div>
    </div>
`;
